import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import { getSize, NumberInput } from '@lib/common';
import styled from '@xstyled/styled-components';
import { Select, Tooltip } from 'antd';
import Image from 'next/image';
import { useMemo, forwardRef } from 'react';
import { useQuestionContext } from '../../../../core';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledLayout = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  width: 100%;\n  padding: ", " ", ";\n  background-color: #faf8fc;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  box-shadow: ", ";\n  transition: all 0.2s ease;\n"])), getSize('padding12'), getSize('padding12'), getSize('padding16'), getSize('radiusSm'), function (_ref) {
  var $isSelected = _ref.$isSelected;
  return $isSelected ? '#2563eb' : '#e2ebf0';
}, function (_ref2) {
  var $isSelected = _ref2.$isSelected;
  return $isSelected ? '0 0 0 3px rgba(37, 99, 235, 0.1)' : 'none';
});
var StyledPrefix = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 ", ";\n  margin: 0;\n  background-color: #dbeafe;\n  color: #2563eb;\n  border-radius: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  white-space: nowrap;\n  min-width: 60px;\n  border: 1px solid #bfdbfe;\n  user-select: none;\n"])), getSize('padding8'), getSize('radiusS'), getSize('typo14'));
var StyledSelectWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  .ant-select-selector {\n    border-radius: ", " !important;\n    border-color: #cbd5e1 !important;\n  }\n  .ant-select-selection-item {\n    background: #e2e8f0 !important;\n    border: none !important;\n    border-radius: 4px !important;\n  }\n"])), getSize('radiusS'));
var StyledScoreInput = styled(NumberInput)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 90px;\n\n  .ant-input-number-group-addon {\n    background-color: transparent;\n    border-left: none;\n    padding: 0 8px;\n  }\n  .ant-input-number {\n    border-radius: ", " 0 0 ", " !important;\n  }\n  .ant-input-number-group-addon {\n    border-radius: 0 ", " ", " 0 !important;\n  }\n"])), getSize('radiusS'), getSize('radiusS'), getSize('radiusS'), getSize('radiusS'));
var StyledActionButtonWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #f8fafc;\n    border-color: #1a5aff;\n  }\n"])));
var StyledSelectInput = styled(Select)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  .ant-select-selector {\n    padding: ", ";\n    min-height: 40px;\n  }\n"])), getSize('padding8'));
export var FibAnswerItem = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var answer = _ref3.answer,
      index = _ref3.index,
      score = _ref3.score,
      onUpdateAnswer = _ref3.onUpdateAnswer,
      onUpdateScore = _ref3.onUpdateScore,
      onDelete = _ref3.onDelete,
      readonly = _ref3.readonly,
      fillInBlankLabel = _ref3.fillInBlankLabel,
      isSelected = _ref3.isSelected;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var fibQuestion = question; // Calculate display index based on question index, same as blank component

  var displayIndex = useMemo(function () {
    var _question$index;

    var questionIndex = (_question$index = question === null || question === void 0 ? void 0 : question.index) !== null && _question$index !== void 0 ? _question$index : 1; // question.index is 1-based

    return questionIndex + index; // index is 0-based from array, so add to questionIndex
  }, [question === null || question === void 0 ? void 0 : question.index, index]); // Get all existing answer descriptions to suggest as tags

  var existingAnswerTags = useMemo(function () {
    var tags = new Set();
    fibQuestion.answers.forEach(function (ans) {
      if (ans.description) {
        ans.description.split('|').forEach(function (tag) {
          if (tag.trim()) {
            tags.add(tag.trim());
          }
        });
      }
    });
    return Array.from(tags);
  }, [fibQuestion.answers]);
  var selectedValues = useMemo(function () {
    if (!answer.description) return [];
    return answer.description.split('|').filter(function (v) {
      return v.trim();
    });
  }, [answer.description]);

  var handleChange = function handleChange(values) {
    // Join with "|" delimiter
    var value = values.join('|');
    onUpdateAnswer(value);
  };

  return /*#__PURE__*/_jsxs(StyledLayout, {
    ref: ref,
    $isSelected: isSelected,
    children: [/*#__PURE__*/_jsxs(StyledPrefix, {
      children: ["[Blank ", displayIndex, "]"]
    }), /*#__PURE__*/_jsx(StyledSelectWrapper, {
      children: /*#__PURE__*/_jsx(StyledSelectInput, {
        mode: "tags",
        placeholder: fillInBlankLabel.addAnswerDescriptionPlaceholder,
        defaultValue: selectedValues,
        onChange: handleChange,
        disabled: readonly,
        tokenSeparators: ['|'],
        allowClear: true,
        notFoundContent: null // Show existing tags as suggestions
        ,
        options: existingAnswerTags.filter(function (tag) {
          return !selectedValues.includes(tag);
        }).map(function (tag) {
          return {
            label: tag,
            value: tag
          };
        })
      })
    }), /*#__PURE__*/_jsx(StyledScoreInput, {
      defaultValue: score,
      onChange: function onChange(val) {
        if (val !== null && val !== undefined) {
          onUpdateScore(Number(val));
        }
      },
      disabled: readonly,
      addonAfter: fillInBlankLabel.score,
      min: 0,
      max: 100,
      step: "0.25"
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: fillInBlankLabel.deleteBlank,
      placement: "bottom",
      children: /*#__PURE__*/_jsx(StyledActionButtonWrapper, {
        onClick: onDelete,
        children: /*#__PURE__*/_jsx(Image, {
          src: "/icons/delete.svg",
          width: 14,
          height: 14,
          alt: "delete"
        })
      })
    })]
  });
});
FibAnswerItem.displayName = 'FibAnswerItem';